// Small scroll utilities shared between the top nav and pages that
// consume cross-page scroll-target instructions.

const HEADER_OFFSET = 80; // sticky header height + breathing room

export function smoothScrollTo(target) {
  if (target === 'top') {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return;
  }
  const el = document.querySelector(target);
  if (el) {
    const top = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
    window.scrollTo({ top, behavior: 'smooth' });
  }
}
